// src/components/salon/SalonNotFound.js
import React from "react";
import { Link, useParams } from "react-router-dom";
import "./SalonNotFound.css";

export default function SalonNotFound() {
    const { token } = useParams();

    return (
        <div className="salon-not-found">
            <h2>❌ Salon Not Found</h2>
            <p>
                The salon link you tried to open is invalid or has expired.
            </p>
            {token && (
                <p className="token-info">
                    Token: <span>{token}</span>
                </p>
            )}
            <Link to="/home" className="btn btn-primary">
                Go Back Home
            </Link>
        </div>
    );
}
